module.exports = __webpack_public_path__ + "media/images/front/pc/dummy/ranking02-4348656e02a20655097d9a1d5441e7a4.png";